import throttle from 'lodash/throttle';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import { RadioGroup, Radio } from '@zocdoc-frontend-common/components-radio';
import {
    breakpoint,
    getWindowWidth,
    Breakpoints,
} from '@zocdoc-frontend-common/styles-grid';
import { RadioGroupOrientations } from '../NewOrExistingPatient/constants';
import { YES_NO_VALUES } from './constants';

/**
 * @param {boolean} props.hasError
 * @param {function(): void} props.onChange
 * @returns {JSX.Element}
 * @constructor
 */
export default function YesNoRadioGroup(props) {
    const { hasError, onChange } = props;

    const [orientation, setOrientation] = useState(calculateOrientation());

    useEffect(() => {
        const handleResize = throttle(function () {
            setOrientation(calculateOrientation());
        }, 100);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <RadioGroup
                hasError={hasError}
                onChangeCallback={onChange}
                orientation={orientation}
            >
                <StyledRadio text="No" value={YES_NO_VALUES.No} />
                <StyledRadio text="Yes" value={YES_NO_VALUES.Yes} />
            </RadioGroup>
            {hasError && <ErrorMessage>Please select a value.</ErrorMessage>}
        </React.Fragment>
    );
}

function calculateOrientation() {
    return getWindowWidth() < Breakpoints.medium
        ? RadioGroupOrientations.Vertical
        : RadioGroupOrientations.Horizontal;
}

const StyledRadio = styled(Radio)`
    ${breakpoint.medium} {
        width: 50%;
    }
`;
